import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,
  // model
  noticeReadInfoModel: []
}

const getters = {
	get: state => state
}

const actions = {
	show ({commit}) {
		// cover
		this.dispatch('core/showModalCover')
		
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
	},
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {noticeReadInfoParams}) {
    return new Promise((resolve, reject) => {
      const isBot = this.state.noticeList.isBot
      const type = isBot ? 'noticeBot' : 'notice'

      ApiManager.request(
        [type],
        ['v1NoticeDeliveryReadInfoGet'],
        [noticeReadInfoParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setNoticeReadInfoModel', res[0].data.noticeReadInfo)
            console.log('noticeReadInfoModel', state.noticeReadInfoModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},
  setNoticeReadInfoModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'noticeReadInfoModel', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
